import React from "react"

const IntlContext = React.createContext()
export const IntlContextProvider = IntlContext.Provider
export const IntlContextConsumer = IntlContext.Consumer
